import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_COMPANY_UNALLOCATED_HISTORIES_GET_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_COMPANY_UNALLOCATED_HISTORIES_GET_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_COMPANY_UNALLOCATED_HISTORIES_GET_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/companies/${id}/unallocated-histories`,
    method: 'GET',
  })
);

export default apiCall;
